import mainSound from "assets/sounds/main_sound.wav";
import navSound from "assets/sounds/nav_sound.wav";
import craftSelectSound from "assets/sounds/craft_select_item.wav";
import craftSound from "assets/sounds/craft_button.wav";
import openPack from 'assets/sounds/open_pack.mp3'
import cardRevealSound from "assets/sounds/card_reveal.wav";
import openSubmenuSound from "assets/sounds/open_submenu.wav";
import closeSubmenuSound from "assets/sounds/close_submenu.wav";
import clearingSound from "assets/sounds/clearing.wav";
import notificationsSound from "assets/sounds/notifications.wav";

const soundMap = {
  main: new Audio(mainSound),
  nav: new Audio(navSound),
  craftSelectItem: new Audio(craftSelectSound),
  crafting: new Audio(craftSound),
  openPack: new Audio(openPack),
  cardReveal: new Audio(cardRevealSound),
  openSubmenu: new Audio(openSubmenuSound),
  closeSubmenu: new Audio(closeSubmenuSound),
  clearing: new Audio(clearingSound),
  notifications: new Audio(notificationsSound),
};

export const preloadSounds = () => {
  Object.values(soundMap).forEach((audio) => {
    audio.preload = 'auto'
    audio.load();
  });

  return soundMap
}
